import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-epdv',
  templateUrl: './epdv.component.html',
  styleUrls: ['./epdv.component.scss']
})
export class EpdvComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
